(function (ws, win) {
    'use strict';

    ws.views.quotePageProductsTable = ws.views.cartTable.extend({
        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote_request',

        $table: $('#comp-qut-table'),
        $clearModal: $('.qut-clear-confirm'),
        apiUrl: globals.path.api.westcon.rfqCartApiUrl,
        saveUrl: globals.path.api.westcon.rfqCartSaveUrl,
        addUrl: globals.path.api.westcon.rfqCartAddUrlUrl,
        clearQuoteUrl: globals.path.api.westcon.rfqCartClearQuoteUrl,

        events: _.extend({}, ws.views.cartTable.prototype.events, {
            'click .qup-add-to-quote': 'addToCart',
            'click .qut-cancel-link': 'confirmCancel',
            'click .qup-save:not(.disabled)': 'saveQuote',
            'click .crt-next-button': 'nextStepToQuote',
            'click .qut-table-notes': 'itemNoteAdds',
            'click .close-button': 'closePopup',
            'click .qut-table-update-comments': 'saveNotes',
            'mouseover .comp-tooltip-label': 'openTooltip',
            'mouseout .comp-tooltip-label': 'closeTooltip',
            'touchstart .comp-tooltip-label': 'openTooltip',
            'touchend .comp-tooltip-label': 'closeTooltip'
        }),

        /**
         * Extend initialize function
         */
        initialize: function () {
            this.TYPE_ADD_CHANGE_QUANTITY = 'quote_change_quantity';
            this.TYPE_REMOVE_CHANGE_QUANTITY = 'quote_change_quantity';
            this.TYPE_REMOVE_REMOVE_PRODUCT = 'quote_remove_product';
            this.TYPE_REMOVE_CLEAR_CART = 'quote_clear_cart';
            this.template = _.template($('#qutCommentsModal').html());
            this.$comment = this.$('.qut-comment');
            this.$modalOverlay = $('.modal-overlay-default');
            this.$itemNotesPopup = $('#item-notes-popup');
            this.$itemNotescomment = this.$('.qut-table-comment-text');
            ws.views.cartTable.prototype.initialize.call(this);
            this.saveModalID = this.$('.qut-save-confirm').attr('id');

            //add products
            this.$addProductsQuickEntry = this.$('.crt-add-products');
            this.$addProductsEmptyError = this.$('.crt-add-items .error-message-exclamation');
            this.productInput = this.$('.crt-add-products');

            //for spinner
            this.$saveButton = this.$('.qup-save');
            this.$addToCartButton = this.$('.qup-add-to-quote');
            this.$gaTrackingId = this.$('#gaTrackingId');

            this.saveRfqId = this.$('#saveRfqId');

            //To stop navigation without saving
            this.checkInputChanges();

            this.$restrictedNumberList = this.$('.numList');
            this.$clearForm = this.$('.qut-clear-form');
            this.$opportunityNotes = this.$('.qut-oppertunity-notes');
            this.responsivePriority = [
                { responsivePriority: 1 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 3 },
                { responsivePriority: 2 },
                { responsivePriority: 1 },
                { responsivePriority: 2 },
                { responsivePriority: 1 },
                { responsivePriority: 3 }
            ];
            this.columnDefs = [
                {
                    targets: [-1, -2],
                    className: 'none'
                }
            ];

            this.cartCategory = 'quote';
        },

        /**
         * Render oppertunity note
         * @param {string} noteValue
         */
        renderOppertunityNote: function(noteValue) {
            this.$opportunityNotes.val(noteValue);
        },

        /**
         * open Tooltip
         * @param {Object} e
         */
        openTooltip: function (e) {
            var $el = $(e.target);
            $el.next().show();
            $el.parent().next().show();
        },

        /**
         * close Tooltip
         */
        closeTooltip: function () {
            this.$('.comp-tooltip-content').hide();
        },

        /**
         * Function called to check if any changes in form
         */
        checkInputChanges: function () {
            this.openPageAlert();

            //if submit button clicks dont stop reload
            $('[type="submit"]').on('click', function () {
                win.onbeforeunload = null;
            });
        },

        /**
         * openPageAlert
         */
        openPageAlert: function () {
            /**
             * Open alert if user navigates away from page without saving changes
             * @returns {string}
             */
            win.onbeforeunload = function () {
                return 'You have made some changes to the below form';
            };
        },

        /**
         * Generate products array from input fields
         * @param {Object} e
         */
        addToCart: function (e) {
            this.cartAction = 'quick entry';
            e.preventDefault();
            this.$errors.hide();
            this.$addProductsQuickEntry.removeClass('error');
            this.$addProductsEmptyError.hide();
            var products = this.$addProductsQuickEntry.val().trim();
            if (!products) {
                this.$addProductsQuickEntry.addClass('error');
                this.$addProductsEmptyError.show();
            } else {
                this.addProducts(products);
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'add_product_quick_entry', '');
                this.productInput.val('');
            }
        },

        /**
         * Launch confirm cancel modal
         * @param {Object} e
         */
        confirmCancel: function (e) {
            e.preventDefault();
            this.eventAgg.trigger(this.cancelModalId);
        },

        /**
         * Cancel entire quote
         */
        cancelQuote: function () {
            this.$clearForm.submit();
        },

        /**
         * Check for notes to push to google Analytics
         */
        nextStepToQuote: function () {
            var notes = this.$opportunityNotes.val();
            if (notes)  {
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'add_note', '');
                _satellite.track('event:addNoteQuote');
            }
        },

        /**
         * Save quote with opportunity notes
         */
        saveQuote: function () {
            var notes = this.$opportunityNotes.val();
            var saveRFQ = new ws.models.saveRFQModel();
            saveRFQ.set({
                opportunityNotes: notes
            });

            //enable Spinner
            this.$saveButton.addClass('spinner-before').prop('disabled', true);

            saveRFQ.save().done(function(response) {
                if (!response.error) {

                    //disable spinner
                    this.$saveButton.removeClass('spinner-before').prop('disabled', false);
                    this.saveRfqId.text(response.code);
                    this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'save', '');
                    _satellite.track('event:saveQuote');
                    this.eventAgg.trigger(this.saveModalID);
                }
            }.bind(this)).fail(function() {
                this.$saveButton.removeClass('spinner-before').prop('disabled', false);
                this.$apiError.show();
            }.bind(this));
        },

        /**
         * Item note add function
         */
        itemNoteAdds: function (e) {
            this.target = $(e.currentTarget);
            $('.qut-table-notes').removeClass('add-selected');
            this.target.addClass('add-selected');
            this.$comment.html(this.template);
            this.Notes = this.target.attr('value');
            $('.qut-table-comment-text').val(this.Notes);
            $('body').addClass('noScroll');
            this.$modalOverlay.addClass('show');
            this.$itemNotesPopup.show();
        },

        /**
         * Item note add Popup close
         */
        closePopup: function () {
            $('body').removeClass('noScroll');
            this.$modalOverlay.removeClass('show');
            this.$itemNotesPopup.hide();
        },

        /**
         * Save Item notes
         */
        saveNotes: function () {
            this.itemNotes = $('.qut-table-comment-text').val();
            var compPartNostr = $('.add-selected').attr('data-part');
            var compPartNo = $.trim(compPartNostr);
            var saveItemNotes = new ws.models.saveItemNotes();
            this.addText = $('.add-selected').attr('data-add');
            var _this = this;
            saveItemNotes.set({
                notes: this.itemNotes,
                partNo: compPartNo
            });

            saveItemNotes.save().done(function (response) {
                $('.add-selected').attr('value', _this.itemNotes);
                if (_this.itemNotes.length > 10) {
                    $('.add-selected').text(_this.itemNotes.substring(0, 10) + '...');
                }
                else if (this.itemNotes == '') {
                    $('.add-selected').text(_this.addText);
                }
                else {
                    $('.add-selected').text(_this.itemNotes);
                }

                _this.closePopup();
            }.bind(this)).fail(function (error) {
                console.log(error);
            }.bind(this));
        },

        /**
         * adobe event trigger
         */
        triggerAdobeEvent: function () {
            _satellite.track('event:cart');
        }
    });
})(westcon, window);
